import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { shape, string, element, number, func, bool } from 'prop-types';
import { ListItem, Name, Link, Text, ChevronRightIcon, SellerItem, SellerText, SellerName } from './breadcrumb-item.styles';

const BreadcrumbItem = _ref => {
  let {
    seller,
    item,
    onClick,
    active
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["seller", "item", "onClick", "active"]);

  const Description = active ? Text : Link;

  if (seller) {
    return /*#__PURE__*/React.createElement(ListItem, {
      "data-testid": "breadcrumb-item-list"
    }, /*#__PURE__*/React.createElement(SellerItem, {
      "data-testid": "breadcrumb-item"
    }, /*#__PURE__*/React.createElement(SellerText, null, seller.text), /*#__PURE__*/React.createElement(SellerName, {
      "data-testid": "breadcrumb-item-name"
    }, /*#__PURE__*/React.createElement("b", null, seller.name))));
  }

  return /*#__PURE__*/React.createElement(ListItem, {
    "data-testid": "breadcrumb-item-list"
  }, item.position > 0 && /*#__PURE__*/React.createElement(ChevronRightIcon, {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement(Description, _extends({
    "data-testid": "breadcrumb-item",
    onClick: !active ? e => onClick(e, item) : null,
    active: active,
    href: item.url
  }, props), /*#__PURE__*/React.createElement(Name, null, item.icon || item.name)));
};

BreadcrumbItem.defaultProps = {
  seller: undefined,
  item: undefined,
  active: true,
  onClick: () => {}
};
process.env.NODE_ENV !== "production" ? BreadcrumbItem.propTypes = {
  seller: shape({
    name: string
  }),
  onClick: func,
  item: shape({
    url: string,
    name: string,
    position: number,
    icon: element
  }),
  active: bool
} : void 0;
export default BreadcrumbItem;